var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7852 0C11.0999 0 10.5439 0.555936 10.5439 1.24126V5.37934C10.5439 6.06466 11.0999 6.62059 11.7852 6.62059C12.4705 6.62059 13.0274 6.06466 13.0274 5.37934V1.24126C13.0274 0.555936 12.4705 0 11.7852 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7852 17.3794C11.0999 17.3794 10.5439 17.9353 10.5439 18.6207V22.7587C10.5439 23.4441 11.0999 24 11.7852 24C12.4705 24 13.0265 23.4441 13.0265 22.7587V18.6207C13.0274 17.9353 12.4705 17.3794 11.7852 17.3794Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88588 7.61456L3.30268 5.5455C2.70829 5.20331 1.94987 5.40675 1.60674 6.00018C1.26455 6.59456 1.46705 7.35392 2.06142 7.69705L5.64462 9.76612C6.23807 10.1083 6.99743 9.90487 7.34056 9.3105C7.68368 8.71705 7.47931 7.95769 6.88588 7.61456Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9365 16.304L18.3533 14.235C17.7598 13.8928 17.0004 14.0962 16.6573 14.6896C16.3151 15.284 16.5186 16.0434 17.112 16.3865L20.6952 18.4556C21.2896 18.7978 22.0489 18.5943 22.3921 18C22.7333 17.4065 22.5299 16.6471 21.9365 16.304Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6454 14.235L2.0622 16.304C1.46875 16.6462 1.26532 17.4065 1.60752 18C1.94971 18.5934 2.71003 18.7987 3.30345 18.4546L6.88665 16.3865C7.4801 16.0443 7.68352 15.284 7.34133 14.6896C6.99914 14.0962 6.23882 13.8928 5.6454 14.235Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3542 9.7658L21.9374 7.69673C22.5318 7.35361 22.7352 6.59329 22.3921 5.99893C22.0499 5.40548 21.2896 5.20205 20.6952 5.54518L17.112 7.61425C16.5186 7.95644 16.3151 8.7158 16.6573 9.31018C17.0004 9.9055 17.7608 10.1089 18.3542 9.7658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.ff02100369754528f63ef327c1983ff6.svg";
export { ForwardRef as ReactComponent };